import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['note']

  connect () {
    this.sync()
  }

  sync () {
    if (!this.hasNoteTarget) return

    const checkbox = this.element.querySelector('input[type="checkbox"]')
    this.noteTarget.classList.toggle('hidden', !checkbox?.checked)
  }
}
